export default __webpack_public_path__ + "static/media/23AndMe.7fc77e2c.png";